import { Injectable, Type } from '@angular/core';
import { from, Subject, take, tap } from 'rxjs';

import { ModalComponent } from '../components/modal.component';
import { ModalOptions } from '../data/modal.data';

@Injectable({ providedIn: 'root' })
export class ModalService {
  get isActive(): boolean {
    return this._modalHost.isActive;
  }

  private openedSubject = new Subject<void>();
  private closedSubject = new Subject<void>();
  readonly opened$ = this.openedSubject.asObservable();
  readonly closed$ = this.closedSubject.asObservable();

  private _modalHost!: ModalComponent;
  private _opening = false;

  init(modalHost: ModalComponent): void {
    this._modalHost = modalHost;
  }

  open<T>(promise: Promise<Type<T>>, options: ModalOptions<T> = {}) {
    if (this._opening) {
      return;
    }
    this._opening = true;
    from(promise)
      .pipe(
        take(1),
        tap(c => {
          this._modalHost.open(c, options);
          this._opening = false;
          this.openedSubject.next();
        }),
      )
      .subscribe();
  }

  back() {
    this._modalHost.back();
    this.closedSubject.next();
  }

  close() {
    this._modalHost.close();
    this.closedSubject.next();
  }
}
